<template>
  <div>
    <!-- Header -->
    <Header :headerTitle="$t('m.changeMobile.title')" :hasBackBtn="true"></Header>
    <!-- section -->
    <section class="main-container">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="10">
            <b-form-input id="input-default" type="text" :placeholder="$t('m.changeMobile.phoneLength')"
                          v-model="phoneCode" maxlength="11"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1" id="code">
          <b-col sm="10" style="margin-top:10px;">
            <b-form-input
                id="input-default"
                type="text"
                :disabled="phoneCode==''"
                :placeholder="$t('m.changeMobile.code')"
                class="idenCode"
                maxlength="4"
                v-model="identifyingCode"
            ></b-form-input>
            <!-- button -->
            <b-button href="#" class="idenCodeText" :disabled="!isNaN(this.seconds) || phoneCode.length!=11">
              <span style="display: block" @click="onUserCode()">
                {{seconds}}
                <i v-if="!isNaN(this.seconds)">S</i>
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>

      <b-button href="#" id="submitLogin" :disabled="phoneCode.length!=11 || identifyingCode.length!=4">
        <span style="display: block" @click="updateUserPhone">{{$t('m.changeMobile.Updatesuccess')}}</span>
      </b-button>
    </section>
    <b-modal id="changeMobile" ref="modal.changeMobile" centered hide-header :ok-title="$t('m.changeMobile.ok')" :cancel-title="$t('m.changeMobile.cancel')" @cancel="cancel()">
      <p>{{$t('m.changeMobile.changeWarning')}}</p>
    </b-modal>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
  import {userInfo} from "../../api/user.js";
  import {loginByUsersend} from "../../api/login.js";
  import {updateUserPhone} from "../../api/mobile.js";

  export default {
    name: "changeMobile",
    data() {
      return {
        seconds: "", //秒
        phoneCode: "", //手机号
        identifyingCode: "", //验证码
        message: "", //提示信息
        tipShow: "0", //是否提示
        tipType: "", //提示类型
        resultList: {}, //用户数据
        intervalTime:null,
        once: 0//修改的次数
      };
    },
    methods: {
      cancel() {
        window.history.back();
      },

      hiddenDialog() {
        this.$refs['modal.changeMobile'].hide()
      },
      //获取手机验证码
      onUserCode: function () {
        if (this.resultList.phone == this.phoneCode) {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = this.$t('m.changeMobile.newAndOldPhone');
          this.tipType = "error";
          return false;
        }
        if (!/^((1[3-9][0-9]))\d{8}$/.test(this.phoneCode)) {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = this.$t('m.changeMobile.errorPhoneformat');
          this.tipType = "error";
          return false;
        } else {
          this.seconds = 59;
         this.intervalTime= setInterval(() => {
            if (this.seconds > 1) {
              this.seconds--;
            } else {
              this.seconds = this.$t('m.changeMobile.getCode');
            }
          }, 1000);
          loginByUsersend({phone: this.phoneCode}).then(
              response => {
                if (response.data.status == 200) {
                  this.tipShow = "1" + Math.random() * 1000;
                  this.message = this.$t('m.changeMobile.sucessSend');
                  this.tipType = "success";
                } else {
                  this.tipShow = "1" + Math.random() * 1000;
                  this.tipType = "warning";
                  this.message = response.data.message;
                }
              },
              err => {
                reject(err);
              }
          );
        }
      },
      //修改手机号
      updateUserPhone: function () {
        if (this.resultList.phone == this.phoneCode) {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = this.$t('m.changeMobile.newAndOldPhone');
          this.tipType = "error";
          return false;
        }
        if (!/^((1[3-9][0-9]))\d{8}$/.test(this.phoneCode)) {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = this.$t('m.changeMobile.errorPhoneformat');
          this.tipType = "error";
          return false;
        }
        updateUserPhone({
          phone: this.phoneCode,
          verificationCode: this.identifyingCode
        }).then(
            response => {
              if (response.data.status == 200) {
                this.tipShow = "1" + Math.random() * 1000;
                this.message = this.$t('m.changeMobile.successMeassage');
                this.tipType = "success";
                localStorage.removeItem("token");
                this.$router.push("/Login");
              } else {
                this.tipShow = "1" + Math.random() * 1000;
                this.tipType = "warning";
                this.message = response.data.message;
              }
            },
            err => {
              reject(err);
            }
        );
      }, //获取数据
      loadUserInfo: function () {
        userInfo().then(
            response => {
              if (response.data.status == 200) {
                this.resultList = response.data.result;
                if (this.resultList.changeTime >= 3) {
                  this.$refs['modal.changeMobile'].show()
                }
              } else {
                this.tipShow = "1" + Math.random() * 1000;
                this.message = response.data.message;
                this.tipType = "warning";
              }
            },
            err => {
              reject(err);
            }
        );
      }
    },
    created() {
      this.loadUserInfo();
      this.seconds = this.$t('m.changeMobile.getCode');
    },destroyed() {
    if (this.intervalTime != null) {
      clearInterval(this.intervalTime);
    }
  }
  };
</script>

<style scoped>
  section {
    color: #0066B1;
    width: 100%;
  }

  section h3 {
    margin: 0px;
  }

  section .idenCode {
    width: 60%;
    display: inline-block;
    float: left;
  }

  .container-fluid {
    margin-top: 20px;
  }

  .container-fluid .row {
    margin: 0px;
  }

  .container-fluid .col-sm-10 {
    margin: 0 20px;
  }

  .container-fluid .idenCodeText {
    float: right;
    line-height: 31px;
    background-color: #0066B1;
    border: 0;
  }

  #submitLogin {
    width: 81%;
    background-color: #0066B1;
    line-height: 35px;
    font-size: 18px;
    margin-top: 20px;
  }

  .container-fluid .col-sm-10 {
    padding: 0;
  }

  .container-fluid .col-sm-10 input {
    background-color: #f2fbff;
    border: 1.3px solid #0066B1;
    height: 45px;
  }

  .container-fluid .idenCodeText span i {
    font-size: 13px;
  }

  .container-fluid #code .col-sm-10 input {
    width: 55%;
  }

  .container-fluid #code .col-sm-10 a {
    width: 42%;
    text-align: center;
  }

  .tip {
    background: #2c3e50;
    position: absolute;
    margin: auto auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.3;
    border-radius: 10px;
    width: 40%;
    padding-bottom: 40%;
    height: 0px;
  }

  .tip img {
    margin: 10px 0;
    width: 50%;
  }

  .tip p {
    color: #fff;
  }
</style>
<style>
  #changeMobile .modal-content {
    margin: 0 auto;
    width: 80%;
  }

  #changeMobile p {
    padding: 0 12px;
    margin-bottom: 0;
    text-align: center;
  }

  #changeMobile .modal-body {
    padding: 25px 0;
  }

  #changeMobile footer {
    padding-top: 5px;
    padding-bottom: 7px;
  }

  #changeMobile footer button {
    width: 100%;
    background: #fff;
    border: 0px;
    color: black;
  }

  #changeMobile footer .btn-primary {
    border-left: 1px solid rgb(222, 226, 230);
    border-radius: 0;
  }
</style>





